// extracted by mini-css-extract-plugin
export default {"value":"_51Fbq8OLSkp0yamscSZDiw=="};